export enum RegistrationStep {
    Account,
    PersonalDataFillingChoice,
    PersonalData,
    PersonalDataAfterError,
    EmailVerification,
    GamingLimits,
    PersonalDataUnverified,
    PersonalDataVerificationChoice,
    Deposit,
    Success,
    Unsuccess,
    Pending,
    EmailVerificationPending,
    EmailVerificationFail,
    EmailVerificationSuccess,
    Ocr,
    OcrQRCode,
    OcrContinueOnMobile,
    OcrPending,
    OcrComplete,
    OcrFailed,
    OcrDepositPending,
    OcrDepositRejected,
}
